import React from 'react';
import FadeIn from "../../FadeIn";
import styles from './Loader.module.scss';
const Loader = (props) => {
    return (React.createElement(FadeIn, Object.assign({ className: styles.container }, props),
        React.createElement("div", { className: styles.title }),
        React.createElement("ul", null,
            React.createElement("li", null,
                React.createElement("span", null),
                " ",
                React.createElement("span", null),
                React.createElement("span", null),
                " ",
                React.createElement("span", null)),
            React.createElement("li", null,
                React.createElement("span", null),
                " ",
                React.createElement("span", null),
                React.createElement("span", null),
                " ",
                React.createElement("span", null)),
            React.createElement("li", null,
                React.createElement("span", null),
                " ",
                React.createElement("span", null),
                React.createElement("span", null),
                " ",
                React.createElement("span", null)),
            React.createElement("li", null,
                React.createElement("span", null),
                " ",
                React.createElement("span", null),
                React.createElement("span", null),
                " ",
                React.createElement("span", null)),
            React.createElement("li", null,
                React.createElement("span", null),
                " ",
                React.createElement("span", null),
                React.createElement("span", null),
                " ",
                React.createElement("span", null)))));
};
export default Loader;
//# sourceMappingURL=Loader.js.map